<template>
    <div>
        <span v-if="inspection.status.typename === 'not_submitted'" class="label label-default" >
            DRAFT
        </span>
        <span v-if="inspection.status.typename === 'submitted'"  class="label label-info" >
            SUBMITTED
        </span>
        <span v-if="inspection.status.typename === 'validated'" class="label label-success" >
            APPROVED
        </span>
        <span v-if="inspection.status.typename === 'rejected'" class="label label-danger" >
            REJECTED
        </span>
        <span v-if="inspection.status.typename === 'modified'" class="label label-warning" >
            MODIFIED
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            inspection: {
                status: null
            }
        }
    };
</script>



// WEBPACK FOOTER //
// inspection-status-badge.vue?5d38762d